<template style="display: flex">
    <v-card style="width: 60%; margin:0 auto; padding:12px" light>
        <v-row>
            <v-col cols="auto">
                <v-icon @click="close">mdi-close</v-icon>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>

        <v-row width="100%" class="ma-0 pa-0">
            <v-tabs v-model="active_tab" align-tabs="start" light>
                <v-tab class="tool-navigation-bar" href="#addUser">Add users</v-tab>
                <v-tab class="tool-navigation-bar" href="#inviteUser">Invite user</v-tab>
            </v-tabs>
        </v-row>

        <v-row>
        <v-tabs-items
            class="ma-0 pa-0"
            v-model="active_tab"
            style="width: 100%"
        >
            <v-tab-item
                style="height: 100%; max-height: 100%; width: 100%"
                value="addUser"
            >
                <v-row width="100%" class="ma-0 pa-0" style="height:7vh">
                    <v-text-field
                        class="ma-0 pa-3"
                        label="Search user"
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        hide-details="auto"
                        @input="search_user_debounce"
                    ></v-text-field>
                </v-row>
                <v-row width="100%" class="ma-0 pa-0">
                    <v-list-item-group
                        v-model="settings"
                        multiple
                        active-class=""
                        style="height:60vh; overflow-y: auto; width: 100%"
                    >
                        <v-list-item v-for="(user, userId) in filteredUsers" :key="user.email">
                            <v-list-item-action>
                                <v-checkbox color='primary' v-model="selectedUsers" :value="userId"></v-checkbox>
                            </v-list-item-action>
                
                            <v-list-item-content>
                                <v-list-item-title>{{user.name}}</v-list-item-title>
                                <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-row>
                <v-row class="ma-0 pa-0" justify="space-around">
                    <v-col cols="auto" >
                        <v-btn color='primary' outlined class="card-action" @click="close">
                            Cancel
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn  color='primary' class="card-action" :disabled="selectedUsers.length < 1" @click="add_members_to_org">
                            Confirm
                        </v-btn>
                    </v-col>
                </v-row>
            </v-tab-item>
            <v-tab-item
                style="height: 100%; max-height: 100%; width: 100%"
                value="inviteUser"
            >
                <v-row width="100%" class="ma-0 pa-0">
                    <div style="height: 67vh; width:100%;">
                        <v-text-field
                            class="ma-0 pa-3"
                            label="Invite user by email"
                            v-model="inviteeEmail"
                        ></v-text-field>
                    </div>
                </v-row>
                <v-row class="ma-0 pa-0" justify="space-around">
                    <v-col cols="auto" >
                        <v-btn color='primary' outlined class="card-action" @click="close">
                            Cancel
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color='primary' class="card-action" @click="invite_member_to_org">
                            Invite
                        </v-btn>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs-items>
    </v-row>
    </v-card>
</template>

<script>
import debounce from 'lodash.debounce';
import admin_api_caller from "@/javascript/user_org_management";
import {
  ALERT_GENERIC_MESSAGE,
  ALERT_TYPE_SUCCESS,
  ALERT_TYPE_ERROR,
  SUCCESS_USER_INVITATION_MESSAGE,
  SUCCESS_ADD_USER_MESSAGE,
} from "@/constants/constants.js";
export default {
    name: 'AddUserCard',
    props: [
        'availableUsers',
    ],
    
    data: () => ({
        selectedUsers: [],
        inviteeEmail: '',
        active_tab: 'addUser',
        user_search_text: '',
    }),

    computed: {
        filteredUsers() {

            let filtereduser = {}
            if(this.user_search_text == ''){
                return this.availableUsers;
            } else {
                for(let userId in this.availableUsers){
                    let user = this.availableUsers[userId];
                    if(
                        user.email.toLowerCase().includes(this.user_search_text.toLowerCase()) || 
                        (user.first_name + " " + user.last_name).toLowerCase().includes(this.user_search_text.toLowerCase())
                    ){
                        filtereduser[userId] = user;
                    }
                }
            }
            return filtereduser;
        }
    },

    methods: {
        add_members_to_org: async function () {
            let userIds = this.selectedUsers
            let token = await this.$auth.getTokenSilently();
            let resp = await admin_api_caller
                .add_org_members(token, this.$auth.user.org_id, userIds)
                .then((resp) => {
                if (resp["success"]) {
                    return resp["data"];
                }
                return false;
                })
                .catch((e) => {
                console.log(e);
                return false;
                });
            if (resp && resp["response_code"] == 204) {
                this.$emit("close_add_user", ALERT_TYPE_SUCCESS, SUCCESS_ADD_USER_MESSAGE);
            } else {
                this.$emit("close_add_user", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }
        },
        invite_member_to_org: async function () {
            let inviteeEmail = this.inviteeEmail.trim();
            let token = await this.$auth.getTokenSilently();
            let resp = await admin_api_caller
                .invite_org_member(
                    token,
                    this.$auth.user.org_id,
                    this.$auth.user.name,
                    inviteeEmail
                )
                .then((resp) => {
                    if (resp["success"]) {
                        return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log(e);
                    return false;
                });
            if (resp && (resp["response_code"] == 200 || resp["response_code"] == 201)) {
                this.$emit("close_add_user", ALERT_TYPE_SUCCESS, SUCCESS_USER_INVITATION_MESSAGE);
            } else {
                this.$emit("close_add_user", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }
        },
        close: function() {
            this.$emit("close_add_user")
        },
        search_user_debounce: debounce(function(value){
            this.user_search_text = value;
        } ,200),
    }
}
</script>
<style>
    .card-title{
        font-family: 'Poppins' !important;
        font-weight: 800 !important;
        font-size: 1.2em !important;
    }
    .card-section-title{
        font-family: 'Poppins' !important;
        font-weight: 600 !important;
        font-size: 1.2em !important;
    }
    .card-action{
        font-family: 'Poppins' !important;
        font-weight: 400 !important;
        font-size: 0.9em !important;
    }
</style>
  